import "./About.html";
import "./About.scss";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import AboutComponentController from "./AboutComponentController";

export class AboutComponent implements ng.IComponentOptions {
    public bindings: any;
    public controller: Injectable<IControllerConstructor>;
    public templateUrl: string;
    public transclude: boolean;

    constructor() {
        this.bindings = {};
        this.controller = AboutComponentController;
        this.templateUrl = "/App/Components/About/About.html";
    }
}

module("mmManagePortal").component("irAbout", new AboutComponent());
